import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services/currency.service';

@Pipe({
    name: 'currencyTemplate',
    standalone: false
})
export class CurrencyTemplatePipe implements PipeTransform {
  constructor(private currencyService: CurrencyService) { }

  /**
   *
   * @param value The Input String
   * @param args Options to be used with that Pipe: full == eur to Euro (€), chf to Schweizer Franken (chf)
   */
  transform(value: any, args?: any): any {
    if (!args) {
      return this.currencyService.cleanName(value);
    }

    if (args === 'full') {
      return this.currencyService.getCurrencyLabel(value);
    }

    return value;
  }
}
